const z = require('zod')

const LocaleCode = z.enum(['cs', 'en'])

module.exports.LocaleCode = LocaleCode
